import React from "react";
import { SvgComponent } from "@commons/Componentes/SvgComponent/SvgComponent";

const TONO_REVISION = {
  P: "pendiente",
  A: "validada",
  C: "validada",
  R: "riesgo"
};

const Dato = ({ etiqueta, valor }) =>
  valor || valor === 0 ? (
    <div className="citrus-ia-dato">
      <span className="citrus-ia-dato__etiqueta">{etiqueta}</span>
      <span className="citrus-ia-dato__valor">{valor}</span>
    </div>
  ) : null;

export const RevisionDatos = ({ respuesta }) => (
  <div className="citrus-ia-ficha">
    <div className="citrus-ia-ficha__estado">
      <span className={`citrus-gpt-tag citrus-gpt-tag--${TONO_REVISION[respuesta.EstatusRevision] || "neutra"}`}>
        {respuesta.EstatusRevisionDesc}
      </span>
      {respuesta.Riesgo === "high" && (
        <span className="citrus-gpt-tag citrus-gpt-tag--riesgo">
          <SvgComponent iconName="alert" width="13px" height="13px" fill="currentColor" />
          Riesgo alto
        </span>
      )}
    </div>

    <div className="citrus-ia-ficha__datos">
      <Dato etiqueta="Preguntada por" valor={respuesta.CrearUsuario} />
      <Dato etiqueta="Fecha" valor={respuesta.Fecha} />
      <Dato etiqueta="Veces consultada" valor={respuesta.VecesConsultada} />
      <Dato etiqueta="Riesgo" valor={respuesta.RiesgoDesc} />
      <Dato etiqueta="Módulo" valor={respuesta.ContextoModulo} />
      <Dato etiqueta="Pantalla" valor={respuesta.ContextoPantalla} />
    </div>

    {respuesta.EvidenciaInsuficiente && (
      <p className="citrus-gpt-msg__aviso">
        Evidencia insuficiente: la documentación no cubre del todo la pregunta.
      </p>
    )}
  </div>
);
